export const palette = {
  primary: '#09883F',
  accent: '#2DB669',
  neutral: '#F3F3F3',
}
